import { createImageUrl } from '@nrk/serum-imagecrop-utils';

export var IMAGE_WIDTHS = [320, 450, 650, 768, 900, 1280, 1600, 1920, 2400];

export function createResponsiveSrcSet(opts) {
  var id = opts.id,
      ratio = opts.ratio,
      quality = opts.quality;


  return IMAGE_WIDTHS.map(function (width) {
    var imageUrl = createImageUrl({ id: id, width: width, ratio: ratio, quality: quality });
    return imageUrl + ' ' + width + 'w';
  }).join(', ');
}


// WEBPACK FOOTER //
// ./node_modules/@nrk/dh-feature-components/dist/module/serum/helpers.js